import Popup from "../../../ui/Popup/Popup";

const RejectInformer = ({ children }) => {
  return <Popup withIcon chatIcon>{children}</Popup>;
};

export default RejectInformer;
